export const sidebarSettings = [
  {
    title: "Административные процедуры",
    id: "procedures",
    listModal: [
      {
        title: "Регистрация маломерных судов",
        id: "smallboatsreg",
        show: "SMALL_BOATS_REG",
      },
      {
        title: "Регистрация изменений сведений",
        id: "reginformationchanges",
        show: "REG_INFORMATION_CHANGES",
      },
      {
        title: "Техническое освидетельствование судов",
        id: "techexamination",
        show: "TECH_EXAMINATION",
      },
      {
        title: "Выдача судового билета",
        id: "shipsticket",
        show: "SHIPS_TICKET",
      },
      {
        title: "Выдача дубликата судового билета",
        id: "dupshipsticket",
        show: "DUPSHIPS_TICKET",
      },
      {
        title: "Выдача удостоверений",
        id: "issuing-certificates",
        show: "ISSUING_CERTIFICATES",
      },
      {
        title: "Печать удостоверений",
        id: "print-certificates",
        show: "PRINT_CERTIFICATES",
      },
      {
        title: "Обмен удостоверений",
        id: "exchange-certificates",
        show: "EXCHAGE_CERTIFICATES",
      },
      {
        title: "Выдача дубликата удостоверения",
        id: "duplicate-certificates",
        show: "DUPLICATE_CERTIFICATES",
      },
      {
        title: "Предоставление информации",
        id: "provisioninformation",
        show: "PROVISION_INFORMATION",
      },
      {
        title: "Журнал регистрации АП",
        id: "logbookAdministrativeProcedures",
        show: "LOGBOOK_ADMINISTRATIVE_PROCEDURES",
      },
      {
        title: "Оплата административных процедур",
        id: "",
        show: "???????????????",
      },
    ],
    isHidden: false,
  },
  {
    title: "Проверка знаний",
    id: "training",
    listModal: [
      {
        title: "Заявление на прохождение обучения",
        id: "applicationfortraining",
        show: "TRAINING_APP",
      },
      {
        title: "Учет слушателей",
        id: "listenerTracking",
        show: "LISTENER_TRACKING",
      },
      {
        title: "Журнал учета слушателей",
        id: "registeroftrainees",
        show: "TRAINING_LOG",
      },
      {
        title: "Учет прошедших обучение",
        id: "record-trained-users",
        show: "TRAINING_REGISTER",
      },
      {
        title: "Журнал учета прошедших обучение",
        id: "record-trained-user-logbook",
        show: "RECORD_TRAINED_USER_LOGBOOK",
      },
      {
        title: "Заявление на проверку знаний",
        id: "app-knowledge-verification",
        show: "TRAINING_CHECK_APP",
      },
      {
        title: "Учет прохождения проверки знаний",
        id: "knoweledge-test-record",
        show: "TRAINING_CHECK",
      },
    ],
    isHidden: true,
  },
  {
    title: "Статистика и аналитика",
    id: "analytics",
    listModal: [
      {
        title: "Учет транспортных аварийных случаев",
        id: "transportaccidents",
        show: "BOAT_INCIDENTS",
      },
      {
        title: "Статистика работы инспектора",
        id: "inspectorworkstat",
        show: "INSPECTOR_WORKSTAT",
      },
      {
        title: "Отчеты ",
        id: "reports",
        show: "REPORTS",
      },
    ],
    isHidden: true,
  },
  {
    title: "База данных",
    id: "database",
    listModal: [
      { title: "Маломерные суда", id: "smallboats", show: "SMALL_BOATS" },
      { title: "Удостоверения", id: "certificates", show: "CERTIFICATES" },
      {
        title: "Базы и сооружения",
        id: "basesbuilding",
        show: "BASES_BUIDING",
      },
    ],
    isHidden: true,
  },
  {
    title: "Обследование баз и сооружений",
    id: "checksAndAudits",
    listModal: [],
    isHidden: true,
    show: "BOAT_PARKING_CHECKS",
  },
  {
    title: "Нормативно-справочная информация",
    id: "nsi",
    listModal: [],
    isHidden: true,
    show: "NSI",
  },
  {
    title: "Администрирование",
    id: "administration",
    listModal: [
      {
        title: "Ведение справочников",
        id: "maintainingDirectories",
        show: "EDIT_REF_BOOKS",
      },
      {
        title: "Ведение шаблонов документов",
        id: "patterns",
        show: "PATTERNS",
      },
      {
        title: "Управление ролями",
        id: "roleManagement",
        show: "ROLE_MANAGMENT",
      },
      {
        title: "Управление учетными записями",
        id: "accountManagement",
        show: "ACCOUNT_MANAGEMENT",
      },
      {
        title: "Аудит действий пользователя в системе",
        id: "auditActionsSystem",
        show: "AUDIT_USERS_ACTIONS",
      },
      {
        title: "Аудит безопасности",
        id: "auditSecurity",
        show: "AUDIT_SECURITY",
      },
    ],
    isHidden: true,
  },
];

const themeSetting = {
  menuContent: "#E4F0FD",
  icon: "#233E5A",
  hover: {
    backgroundColor: "rgb(161, 170, 187)",
  },
};

export const menuItemStyles = {
  SubMenuExpandIcon: {
    color: "#233E5A",
    "&:hover": {
      fontWeight: "500px",
    },
  },
  subMenuContent: ({ level }) => ({
    backgroundColor: level === 0 ? themeSetting.menuContent : "transparent",
  }),
  button: {
    "&:hover": {
      backgroundColor: themeSetting.hover.backgroundColor,
      borderLeft: "3px solid #2E445B",
      color: themeSetting.hover.color,
    },
    "&.active": {
      borderLeft: "3px solid #2E445B",
      fontWeight: 600,
    },
    "&.active:hover": {
      borderLeft: "5px solid #2E445B",
    },
  },
  label: ({ open }) => ({
    fontWeight: open ? 600 : undefined,
  }),
};
